var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploads(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_659_131229)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.652344,
    width: 36,
    height: 36.5751,
    rx: 18,
    fill: "#1C1C1C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3407 21.8629C18.1002 21.8629 17.8987 21.7801 17.7362 21.6145C17.5732 21.4495 17.4917 21.2448 17.4917 21.0004V14.8331L15.8999 16.4504C15.7301 16.6229 15.532 16.7092 15.3056 16.7092C15.0792 16.7092 14.874 16.6157 14.6901 16.4289C14.5203 16.2564 14.4391 16.0514 14.4464 15.8139C14.4532 15.577 14.5344 15.3794 14.6901 15.2213L17.7464 12.1161C17.8313 12.0299 17.9233 11.9686 18.0224 11.9324C18.1214 11.8967 18.2275 11.8789 18.3407 11.8789C18.4539 11.8789 18.56 11.8967 18.6591 11.9324C18.7581 11.9686 18.8501 12.0299 18.935 12.1161L21.9914 15.2213C22.1612 15.3938 22.2424 15.5985 22.235 15.8354C22.2282 16.0729 22.147 16.2707 21.9914 16.4289C21.8216 16.6014 21.6201 16.6911 21.3869 16.698C21.1531 16.7055 20.9514 16.6229 20.7816 16.4504L19.1897 14.8331V21.0004C19.1897 21.2448 19.1085 21.4495 18.9461 21.6145C18.783 21.7801 18.5813 21.8629 18.3407 21.8629ZM13.2468 25.3131C12.7799 25.3131 12.3803 25.1444 12.048 24.8068C11.7152 24.4687 11.5488 24.0624 11.5488 23.588V21.8629C11.5488 21.6185 11.63 21.4135 11.7925 21.2479C11.9555 21.0829 12.1573 21.0004 12.3978 21.0004C12.6384 21.0004 12.8401 21.0829 13.0031 21.2479C13.1656 21.4135 13.2468 21.6185 13.2468 21.8629V23.588H23.4346V21.8629C23.4346 21.6185 23.5162 21.4135 23.6792 21.2479C23.8416 21.0829 24.0431 21.0004 24.2836 21.0004C24.5242 21.0004 24.7257 21.0829 24.8881 21.2479C25.0511 21.4135 25.1326 21.6185 25.1326 21.8629V23.588C25.1326 24.0624 24.9665 24.4687 24.6343 24.8068C24.3015 25.1444 23.9016 25.3131 23.4346 25.3131H13.2468Z",
    fill: "url(#paint0_linear_659_131229)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_659_131229",
    x: -4.5,
    y: -4.34766,
    width: 46,
    height: 46.5752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_659_131229"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_659_131229",
    result: "effect2_innerShadow_659_131229"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_659_131229",
    x1: 18.3407,
    y1: 9.46074,
    x2: 18.3407,
    y2: 27.4626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploads);
export default __webpack_public_path__ + "static/media/uploads.0adde60163dde96bb80341a6d5599b27.svg";
export { ForwardRef as ReactComponent };